import { ServiceHistoryService } from 'api-new/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';

type VauxhallLookupParams = {
  serviceHistoryId: number;
  userId: number;
};

export const useServiceHistoryVauxhallLookupMutation = () =>
  useMutation(
    (input: VauxhallLookupParams) =>
      ServiceHistoryService.postServiceHistoryVauxhallLookup(input.serviceHistoryId, input.userId),
    {
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
      }
    }
  );
